import React, {Component} from 'react'
import {Row} from 'react-bootstrap'
import {connect} from 'react-redux'
import CubeLink from './CubeLink'
import {FiList, FiHeart, FiHelp, FiHorseHat, FiPhoto, FiHorse, FiAddHorse, FiCowboyHat} from '../../Common/ReactIcons/icons'

import '../UserScreen.css'

class DashboardScreen extends Component {
  constructor (props) {
    super(props)
    this.state = {
      user: props.user,
      links: [
        {name: 'ثبت اسب', description: 'با ثبت کردن اطلاعات اسب، ضمن معرفی اسب امکان قرار دادن عکس و آگهی برای آن اسب فراهم می‌شود.', path: '/new-horse', visible: true, icon: <FiAddHorse />},
        {name: 'قرار دادن تصویر اسب', description: 'با قرار دادن عکس اسب، اسب بهتر معرفی شده و احتمال دیده شدن اطلاعات اسب بیشتر می‌شود.', path: '/add-horse-photo', visible: true, icon: <FiPhoto />},
        {name: 'پرورش دهنده هستم', description: 'با اعلام اینکه پرورش دهنده یک اسب هستید، یک صفحه اختصاصی برای شما ایجاد می‌شود که می‌توانید از امکانات خاص آن بهره‌مند گردید.', path: '/i-am-breeder', visible: props.user && !props.user.breederKey, icon: <FiCowboyHat />},
        {name: 'تولیدات من', description: 'صفحه اختصاصی شما به عنوان پرورش دهنده', path: `/breeder/${props.user && props.user.breederKey}`, visible: props.user && props.user.breederKey, icon: <FiCowboyHat />},
        {name: 'مالک هستم', description: 'با اعلام اینکه مالک یک اسب هستید، یک صفحه اختصاصی مالک برای شما ایجاد می‌شود که می‌توانید از امکانات آن بهره‌مند شوید.', path: '/i-am-owner', visible: true, icon: <FiHorseHat />},
        {name: 'اسب‌های من', description: 'صفحه اختصاصی شما به عنوان مالک', path: `/owner/${props.user && props.user.ownerKey}`, visible: props.user && props.user.ownerKey, icon: <FiHorse />},
        {name: 'پیشنهاد تغییر سایت', description: 'پیشنهاد ایجاد تغییر در سایت', path: '/new-features', visible: true, icon: <FiList />},
        {name: 'حمایت از سایت', description: 'با حمایت از سایت به ادامه یافتن پروژه کمک کنید.', path: '/donate', visible: true, icon: <FiHeart />},
        {name: 'آموزش', description: 'آموزش نحوه استفاده از بخش‌های مختلف سایت', path: '/help', visible: true, icon: <FiHelp />}
      ]
    }
  }

  componentWillReceiveProps (nextProps) {
    this.setState({user: nextProps.user})
  }

  render () {
    const {links} = this.state
    return (
      <Row className="Box">
        {links.map((item, index) => item.visible && <CubeLink key={index} target={item} />)}
      </Row>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.user.currentUser
  }
}
export default connect(mapStateToProps)(DashboardScreen)



// WEBPACK FOOTER //
// ./src/components/User/Dashboard/DashboardScreen.js